import api from "../atlasApi";

export const serviceAddTask = (data, token) => {
  return api.post("/horizon/add-edit-task/", data, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: "Token " + token,
    },
  });
};

export const serviceGetTask = (data, token) => {
  return api.post("/horizon/get-task/", data, {
    headers: {
      Authorization: "Token " + token,
    },
  });
};
